const styles = (theme) => ({
	loginPage: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
		margin: "1rem auto",
		maxWidth: "1100px",
	},
	form: {
		display: "flex",
		flexDirection: "column",
		paddingRight: "1rem",
	},
	formField: {
		margin: "1rem",
	},
	image: {
		width: "304px",
		height: "188px",
		marginTop: "-40px",
		marginLeft: "-1.5rem",
	},
	button: {
		width: "14rem",
		borderRadius: "2rem",
		right: "-1rem",
		marginBottom: "1rem",
	},
});

export default styles;
